import Record from "slotworks/model/gameplay/records/record";

export default class BonusRecord extends Record {
    public multiplier: number;
//    public totalWin: number;
    public bonusMultipliers: number[];
    public isJackpotWon: boolean; 
    public awardedMultiplier: number;    
    public freespinsTriggered: boolean = false;
    public retriggers: number; // for freespin
    public freespinsWon: number;
    public freespinsActive: boolean = false;

    public freespinsTotalWinCash: number = 0; // recovery
    public recoversFreespins: boolean;
    public inFreespins: boolean = false;

    public freespinsNext: boolean = false;
}
